// $(window).load(function() {
//   $("body").removeClass("preload");
// });

window.onload = (event) => {
 $("body").removeClass("preload");
};
